export default "__VITE_ASSET__bed64e56__"